@use '../../scss/utility/functions' as utility;

:host {
  --size: #{utility.wb-pixel-to-rem(18px)};

  // used calc here in order to make wb-badge component resizable via --size
  --inner-size: calc(var(--size) * 0.88888); // 18px * 0.88888 = 16px
  --icon-size: calc(var(--size) * 0.66666); // 18px * 0.66666 = 12px

  --background-color: var(--wb-blue-45);
  --text-color: var(--wb-white);

  display: inline-block;
  background-color: transparent;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
}

.wb-icon,
::slotted(.wb-icon) {
  --size: var(--icon-size); // overwrite inner --size of wb-icon
}

.inner {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  inset-block-start: utility.wb-pixel-to-rem(1px);
  inset-inline-start: utility.wb-pixel-to-rem(1px);
  width: var(--inner-size);
  height: var(--inner-size);
  background-color: var(--background-color);
  color: var(--text-color);
  border-radius: 50%;
}

:host([theme='dark']) {
  --background-color: var(--wb-blue-50);
  --text-color: var(--wb-black);
}

:host([variant='warning']) {
  --background-color: var(--wb-yellow-50);
  --text-color: var(--wb-black);
}

:host([variant='error']) {
  --background-color: var(--wb-red-45);
}

:host([variant='success']) {
  --background-color: var(--wb-green-45);
  --text-color: var(--wb-white);
}

:host([variant='error'][theme='dark']) {
  --background-color: var(--wb-red-50);
  --text-color: var(--wb-black);
}

:host([has-border]) {
  background-color: inherit;
}
